import type { SyncEntityType } from '@/domain/types'

const NOTE_TYPES = new Set(['note', 'knowledge', 'inspiration', 'mistake', 'mistake_notebook'])

function finiteNumber(value: unknown, fallback: number | null = 0) {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : fallback
}

function nullableNumber(value: unknown) {
  if (value === null || value === undefined || value === '') return null
  return finiteNumber(value, null)
}

/**
 * 云端包含少量早期版本写入的不完整实体。统一在进入 IndexedDB 前补齐集合、
 * 字符串和数值字段，使一条遗留记录不会让统计或整个复习队列抛异常。
 */
export function normalizeSyncEntity(type: SyncEntityType, value: Record<string, unknown>) {
  if (type === 'note') {
    const tags = Array.isArray(value.tags)
      ? value.tags.filter((tag): tag is string => typeof tag === 'string')
      : []
    const inferredType = value.recordKind === 'question' || value.category === '错题记录'
      ? 'mistake'
      : 'knowledge'
    return {
      ...value,
      type: NOTE_TYPES.has(String(value.type)) ? value.type : inferredType,
      title: typeof value.title === 'string' ? value.title : '',
      content: typeof value.content === 'string' ? value.content : '',
      category: typeof value.category === 'string' ? value.category : null,
      tags,
      source: typeof value.source === 'string' ? value.source : '',
      reviewStage: finiteNumber(value.reviewStage),
      reviewCount: finiteNumber(value.reviewCount),
      nextReviewAtMs: nullableNumber(value.nextReviewAtMs),
      lastReviewedAtMs: nullableNumber(value.lastReviewedAtMs),
    }
  }
  if (type === 'study_session') {
    return {
      ...value,
      durationSeconds: finiteNumber(value.durationSeconds),
      startedAtMs: finiteNumber(value.startedAtMs),
      status: value.status === 'running' || value.status === 'paused' ? value.status : 'completed',
    }
  }
  if (type === 'practice_record') {
    return {
      ...value,
      module: typeof value.module === 'string' ? value.module : '综合',
      correctCount: finiteNumber(value.correctCount),
      totalCount: finiteNumber(value.totalCount),
      durationMinutes: finiteNumber(value.durationMinutes),
    }
  }
  return value
}
